
import React, { PureComponent, useState, useEffect } from 'react';
import styles from './HomeStyle';

// import { Images } from '../../../assets';
import {
    DeviceEventEmitter,
    Image,
    RefreshControl,
    ScrollView,
    Text,
    View,
    TouchableOpacity,
} from 'react-native';

import SkeletonCategory from './skeleton/category';
import  Vpttypes  from './vpttypes';
import { useNavigation } from '@react-navigation/native';
//import {Banner} from 'app-component';

const ReviewSubjectTypes = ({resdata}) => {
    // const navigation = useNavigation();
    const [typesloading, settypesLoading] = useState(true);
    const [typeslist, settypesList] = useState([]);
    useEffect(() => {

        setSubjectTypes();

       
 

    }, []);

   

    const setSubjectTypes = async () => {

        const newarray =[]
         let counter =0;
          
        await resdata.reduce(async (promise, res1) => {
            res1.id =counter;
            newarray.push(res1);
            counter++;
        }, Promise.resolve());

        settypesList(newarray);
        settypesLoading(false);
    }
    return (
        <>


            <View style={styles.viewList}>
                
                {typeslist && typeslist.length > 0 && (
                    <Vpttypes
                        // navigation={navigation}
                        contentContainerStyle={{ paddingHorizontal: 16 }}
                        data={typeslist}
                        horizontal
                        screenname ='REVIEWEXAMCHANGE'
                    />
                )}
                {typesloading && <SkeletonCategory />}
            </View>


        </>
    )
}

export default ReviewSubjectTypes